module.exports = __webpack_public_path__ + "index_pc/img/img_explain_title.382e8669.png";